module.exports = __webpack_public_path__ + "img/1659496982125-aset 1.png.639f017d.webp";